export const faqsPl = [
  {
    q: "Czy budujecie lokalizatory GPS od zera, czy integrujecie gotowe moduły?",
    a: "Oba podejścia. Do PoC często integrujemy sprawdzone moduły GNSS + łączność, potem projektujemy własne PCB pod koszt, baterię i obudowę produkcyjną.",
  },
  {
    q: "Czy tracker GPS obejmuje też dashboard?",
    a: "Zwykle tak. W zapytaniach klienci proszą o urządzenie i panel monitoringu razem — mapa, historia tras, alerty i zarządzanie flotą. Nie rozdzielamy tego na trzy osobne produkty bez potrzeby.",
  },
  {
    q: "Jakie czujniki IoT najczęściej wdrażacie?",
    a: "Temperatura, wilgotność, CO₂/PM, akcelerometry, czujniki otwarcia/drzwi, jakość powietrza oraz sensory przemysłowe po magistralach typu Modbus/CAN — zależnie od branży.",
  },
  {
    q: "Czy robicie trackery antykradzieżowe / wearable z lokalizacją?",
    a: "Tak — od firmware i aplikacji mobilnej po backend. Spotykamy też scenariusze BLE finder networks (np. Find My) obok klasycznego GPS + LTE.",
  },
  {
    q: "Jaka łączność sprawdza się w trackerach?",
    a: "LTE-M / NB-IoT do długiej pracy na baterii, LTE/GSM gdy potrzeba częstszych update’ów, BLE gdy tracker współpracuje z telefonem w pobliżu. Dobieramy stack do scenariusza, nie odwrotnie.",
  },
  {
    q: "Czy dane z sensorów mogą iść do AWS IoT / MQTT?",
    a: "Tak. Integrujemy MQTT/HTTP, AWS IoT Core i własne API — z monitoringiem baterii i retencją danych pod dashboard.",
  },
  {
    q: "Ile trwa MVP trackera z dashboardem?",
    a: "Wąski PoC (lokalizacja + wysyłka + prosty panel) to często 6–12 tygodni. Produkt z obudową, OTA i pełnym UX — dłużej, zależnie od certyfikacji i floty.",
  },
  {
    q: "Czy możecie tylko dashboard do istniejących czujników?",
    a: "Tak. Jeśli macie już sensory (np. ESP32 / Arduino / MQTT), budujemy warstwę odbioru danych, wykresy, alerty i panel administracyjny.",
  },
] as const;
